module.exports = __webpack_public_path__ + "static/img/ic_switch_off@2x.7fad878.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ic_switch_off@2x.png
// module id = wSQg
// module chunks = 1